export default __webpack_public_path__ + "static/media/bottom-arrow.d090e01d.png";